import { Component, OnInit } from '@angular/core';
import {ClientServiceService} from '../../client/client-service/client-service.service';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {first} from 'rxjs/operators';
import {PhysicianService} from '../service/physician.service';
import {TransactionService} from '../../transaction/transaction.service';
import {AppointmentTransactionComponent} from '../../appointment/appointment-transaction/appointment-transaction.component';
import {MatDialog} from '@angular/material';
import {PhysicianTransactionComponent} from '../physician-transaction/physician-transaction.component';
import {Validators} from '@angular/forms';
import {PhysicisanReviewCommentsComponent} from '../physicisan-review-comments/physicisan-review-comments.component';

@Component({
  selector: 'app-physician-view',
  templateUrl: './physician-view.component.html',
  styleUrls: ['./physician-view.component.css']
})
export class PhysicianViewComponent implements OnInit {

    itemsPerPage = 10;
    currentPage = 1;
    public numberOfPhysicians: any;
    regExp = '';
    loading: boolean;
    client: any;
    clientId: any;
    physicianList: any [];
    physicianStatusList: any = [
        { id: '1', value: 'ACTIVE' },
        { id: '2', value: 'BLOCKED' },
        { id: '3', value: 'NEW' }
    ];

    constructor(private physicianService: PhysicianService,
                private clientService: ClientServiceService,
                private transactionService: TransactionService,
                public dialog: MatDialog,
                private toastr: ToastrService, private router: Router) {
        this.clientId = localStorage.getItem('clientId');
        //this.client=this.getClientDetails(this.clientId);

    }

    ngOnInit() {
        this.getAllPhysicians('');

    }

    public getClientDetails(clientId: any) {
        this.clientService.getClientById(clientId)
            .pipe(first())
            .subscribe(data => {
                console.log('client ::' + data.json())
                this.client = data.json();
            }, (error) => {
                this.toastr.error('', 'Please try again');
            });
    }

    getAllPhysiciansByStatus(status){
        this.loading = true;
        this.physicianService.getAllPhysicians(this.currentPage - 1, status, this.itemsPerPage,'')
            .subscribe(data => {
                const response: any = data.json();
                this.physicianList = response.physicians;
                this.numberOfPhysicians = response.numberOfPhysicians;
                console.log(response.clients);

                this.loading = false;
                // TODO - Uncomment below code when using actual API
                // const response: any = data;
                // if (response.status === 200) {
                //   this.userList = response.result;
                // } else {
                //   this.toastr.error('', 'Please try again');
                // }
            }, (error) => {
                this.loading = false;
                // this.toastr.error('', 'Please try again');
            });

    }

    search() {
        console.log('' + this.regExp);
        this.getAllPhysicians(this.regExp);
    }


    public getAllPhysicians(regEx) {
        this.loading = true;
        this.physicianService.getAllPhysicians(this.currentPage - 1, '', this.itemsPerPage,regEx)
            .subscribe(data => {
                const response: any = data.json();
                this.physicianList = response.physicians;
                this.numberOfPhysicians = response.numberOfPhysicians;
                console.log(response.clients);

                this.loading = false;
                // TODO - Uncomment below code when using actual API
                // const response: any = data;
                // if (response.status === 200) {
                //   this.userList = response.result;
                // } else {
                //   this.toastr.error('', 'Please try again');
                // }
            }, (error) => {
                this.loading = false;
                // this.toastr.error('', 'Please try again');
            });
    }

    onChangeStatusFilter(physicianStatus) {
        console.log(physicianStatus);

        if (physicianStatus === 'ALL') {
            this.getAllPhysicians('');
        } else {
            this.getAllPhysiciansByStatus(physicianStatus);
        }
    }

    /*addCampaignForm(pId) {
        this.router.navigate( [ '/elasticcare/add/campaign' ], { fragment: pId } );
    }

    viewCampaign(mrn) {
        this.router.navigate( [ '/elasticcare/campaign' , {mrnParam: mrn}]);

    }*/

    activatePhysician(id: any) {
        this.router.navigate( [ '/elasticcare/physician/physician-details' , {physicianId: id}]);
        /*this.physicianService.updatePhysicianStatus(id, 'ACTIVE')
            .subscribe(data => {
                this.toastr.success('', 'Physician Status Updated Successfully');
                this.getAllPhysicians('');
            }, (error) => {
                const  errorResponse = JSON.parse(error._body);
                if (errorResponse.message !== undefined && errorResponse.message !== null) {
                    this.toastr.error('', errorResponse.message);
                } else {
                    this.toastr.error('', 'Please try again');
                }
            });*/
    }

    getPhysicianTransactionSummary(id: any) {
        this.transactionService.getTransactionByUserId(id)
            .subscribe(data => {
                 console.log(data.json());
                // this.toastr.success('', 'Physician Status Updated Successfully');
                this.dialog.open(PhysicianTransactionComponent, {
                    data: data.json(),
                    height: '800px',
                    width: '1000px',
                });
            }, (error) => {
                const  errorResponse = JSON.parse(error._body);
                if (errorResponse.message !== undefined && errorResponse.message !== null) {
                    this.toastr.error('', errorResponse.message);
                } else {
                    this.toastr.error('', 'Please try again');
                }
            });
    }

    getPhysicianQRCode(id: any) {
        this.loading = true;
        this.physicianService.getPhysicianQRCode(id)
            .subscribe(data => {
                window.open(data.url);
                this.loading = false;
            }, (error) => {

            });
    }

    getPhysicianReviewCommentsSummary(id: any) {
        this.physicianService.getPhysicianComment(id)
            .subscribe(data => {
                 console.log(data.json());
                // this.toastr.success('', 'Physician Status Updated Successfully');
                this.dialog.open(PhysicisanReviewCommentsComponent, {
                    data: data.json(),
                    height: '800px',
                    width: '1000px',
                });
            }, (error) => {
                const  errorResponse = JSON.parse(error._body);
                if (errorResponse.message !== undefined && errorResponse.message !== null) {
                    this.toastr.error('', errorResponse.message);
                } else {
                    this.toastr.error('', 'Please try again');
                }
            });
    }

    pageChanged(event) {
        this.currentPage = event;
        this.getAllPhysicians('');
        console.log(event);
    }

}
